import { ChangeEvent, useCallback, useMemo } from 'react';
import { SearchInput } from '@ds';
import { DataTable } from '@ui';
import { useHubResourcesList } from '@lp/features/RoutePlanner/hooks/useHubResourcesList';
import { RouteHub } from '@lp/features/RoutePlanner/types';
import { SegmentTypeEnum } from '@/api/apis/route';
import { CaseFacility } from '@/api/apis/case';
import { getRenderRoutePlannerHubTableCell, ROUTE_PLANNER_HUB_TABLE_COLUMNS } from './config';

export type RoutePlannerHubsListProps = {
  donorHospital: CaseFacility;
  segmentType: SegmentTypeEnum;
  onSelect: (data: RouteHub, segmentType: SegmentTypeEnum) => void;
};

export const RoutePlannerHubsList = ({ donorHospital, segmentType, onSelect }: RoutePlannerHubsListProps) => {
  const { hubs, isLoading, searchValue, setSearchValue, organType } = useHubResourcesList();

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  };

  const handleSelect = useCallback(
    (hub: RouteHub) => {
      onSelect(hub, segmentType);
    },
    [onSelect, segmentType],
  );

  const renderHubTableCell = useMemo(() => {
    return getRenderRoutePlannerHubTableCell(donorHospital, handleSelect, organType);
  }, [donorHospital, handleSelect, organType]);

  return (
    <div className="flex flex-col place-items-stretch gap-6">
      <SearchInput placeholder="Search" value={searchValue} onChange={onSearchChange} />
      <div
        className="w-full max-h-[325px] overflow-y-auto overflow-x-hidden min-w-0"
        style={{ scrollbarGutter: 'stable' }}
      >
        <DataTable
          type="infinite"
          label="Hubs"
          hidePadding
          baseClassName="w-full min-w-0"
          columns={ROUTE_PLANNER_HUB_TABLE_COLUMNS}
          renderCell={renderHubTableCell}
          data={isLoading ? [] : hubs}
          isLoading={isLoading}
          isFetching={isLoading}
        />
      </div>
    </div>
  );
};
